export default "__VITE_ASSET__175ee1f3__"